
import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Box,
  Typography,
  Tooltip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Button,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { tableCellClasses } from "@mui/material/TableCell";
import { FaEye } from "react-icons/fa";
import { API_BASE_URL } from "../../utils";
import { useAuthHeaders } from "../../components/Token";
import { useNavigate } from "react-router-dom";
import ConfirmationModal from "./ConfirmationModal";
import AlertModal from "../../reuseabelComponent/AlertModal";
import LockIcon from "@mui/icons-material/Lock";
// Styled components
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    // backgroundColor: theme.palette.common.black,
    // color: theme.palette.common.white,
    fontSize: 12,
    fontWeight: 600,
    padding: 10,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 12,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const RequestVendors = () => {
  // const headers = useAuthHeaders();
  const [requestData, setRequestData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedVendorId, setSelectedVendorId] = useState(null);
  const [snackbar, setSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarVarient, setSnackbarVarient] = useState("success");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const header = localStorage.getItem("adminId")
  useEffect(() => {
    fetchData();
  }, []);
  const fetchData = async () => {
    try {
      const headers = {
        Authorization: `Bearer ${header}`,
      };
      const response = await axios.get(`${API_BASE_URL}/vendors`, { headers });
      setRequestData(
        response?.data?.vendors?.filter(
          (item) => item.approvelStatus === "Wait list"
        ) || []
      );
    } catch (error) {
      console.error("Error fetching vendor data:", error);
    }
  };

  const handleApprove = async () => {
    try {
      setLoading(true);
      const headers = {
        Authorization: `Bearer ${header}`,
      };
      const response = await axios.patch(
        `${API_BASE_URL}/vendor/${selectedVendorId}/approve`,
        {},
        { headers }
      );

      if (response.data.success) {
        setSnackbarMessage(response.data.message);
        setSnackbarVarient("success");
        setSnackbar(true);
        setRequestData((prev) =>
          prev.map((vendor) =>
            vendor._id === selectedVendorId ? { ...vendor, approved: true } : vendor
          )
        );
        setShowModal(false);
        setSelectedVendorId(null);
      } else {
        setSnackbarMessage("Failed to approve vendor. Please try again.");
        setSnackbarVarient("error");
        setSnackbar(true);
      }
    } catch (error) {
      console.error("Error approving vendor:", error);
      setSnackbarMessage(error?.response?.data?.message || "Error occurred");
      setSnackbarVarient("error");
      setSnackbar(true);
    }
    finally {
      setLoading(false); // Stop loading
    }
  };

  return (
    <Box p={2}>
      <Typography variant="h6" gutterBottom>
        Vendor Request
      </Typography>

      <TableContainer component={Paper}>
        <Table sx={{ backgroundColor: "#eeeeee", minWidth: 700 }}>
          <TableHead>
            <TableRow>
              <StyledTableCell>Company Name</StyledTableCell>
              <StyledTableCell>Name</StyledTableCell>
              <StyledTableCell>Email</StyledTableCell>
              <StyledTableCell>Phone</StyledTableCell>
              <StyledTableCell>Registered Address</StyledTableCell>
              <StyledTableCell>GSTIN</StyledTableCell>
              <StyledTableCell>Turnover</StyledTableCell>
              <StyledTableCell>Permission</StyledTableCell>
              <StyledTableCell>Action</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {requestData.map((vendor) => (
              <StyledTableRow key={vendor._id}>
                <StyledTableCell>{vendor.companyName}</StyledTableCell>
                <StyledTableCell>
                  {vendor.firstName} {vendor.lastName}
                </StyledTableCell>
                <StyledTableCell>{vendor.email}</StyledTableCell>
                <StyledTableCell>{vendor.phoneNumber}</StyledTableCell>
                <StyledTableCell>
                  <Tooltip title={vendor.registeredAddress} arrow placement="top">
                    <span style={{ color: "#0443c0", cursor: "pointer" }}>
                      {vendor.registeredAddress?.length > 30
                        ? vendor.registeredAddress.slice(0, 30) + "..."
                        : vendor.registeredAddress}
                    </span>
                  </Tooltip>
                </StyledTableCell>
                <StyledTableCell>{vendor.GSTIN}</StyledTableCell>
                <StyledTableCell>{vendor.turnover}</StyledTableCell>

                <StyledTableCell align="center">
                  <IconButton
                    color="success"
                    onClick={() =>
                      navigate(`/vendor-request/vendor-permission/${vendor._id}`)
                    }
                    title="Set Permissions"
                  >
                    <LockIcon fontSize="small" sx={{ mr: 1, }} />
                  </IconButton>
                </StyledTableCell>

                <StyledTableCell align="center">
                  <Box display="flex" gap={1} justifyContent="center">
                    <IconButton
                      color="error"
                      onClick={() => navigate(`/vendor-request/${vendor._id}`)}
                      title="View Vendor"
                    >
                      <FaEye fontSize="medium" />
                    </IconButton>
                    {!vendor.approved && (
                      <Button
                        variant="contained"
                        color="warning"
                        size="small"
                        onClick={() => {
                          setSelectedVendorId(vendor._id);
                          setShowModal(true);
                        }}
                        disabled={loading && vendor._id === selectedVendorId}
                      >
                        {loading && vendor._id === selectedVendorId ? "Approving..." : "Approve"}
                      </Button>

                    )}
                  </Box>
                </StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Modals */}
      <ConfirmationModal
        show={showModal}
        onHide={() => setShowModal(false)}
        onConfirm={handleApprove}
        title="Approve Vendor"
        message="Are you sure you want to approve this vendor?"
        onView={() => navigate(`/vendor-request/${selectedVendorId}`)}
        loading={loading}
      />
      <AlertModal
        
        show={snackbar}
        onHide={() => setSnackbar(false)}
        title={snackbarVarient}
        message={snackbarMessage}
        variant={snackbarVarient}
        showConfirmButton={false}
      />
    </Box>
  );
};

export default RequestVendors;
